import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {ProductResourcesComponent} from './product-resources.component';
import {ProductResourceTileComponent} from './product-resource-tile/product-resource-tile.component';
import {MediaModule} from '@spartacus/storefront';
import {ProductDetailsSectionModule} from '../product-details-section/product-details-section.module';
import {
  ProductSingleResourceTileComponent
} from './product-single-resource-tile/product-single-resource-tile.component';
import {ProductTypeDisplayComponent} from './product-type-display/product-type-display.component';
import {ProductTileContentComponent} from './product-tile-content/product-tile-content.component';
import {TermsAndConditionsModule} from '@app/checkout/checkout-terms-conditions/terms-and-conditions.module';

@NgModule({
  declarations: [
    ProductResourcesComponent,
    ProductResourceTileComponent,
    ProductSingleResourceTileComponent,
    ProductTypeDisplayComponent,
    ProductTileContentComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductResourcesComponent: {
          component: ProductResourcesComponent
        }
      }
    }),
    I18nModule,
    MediaModule,
    ProductDetailsSectionModule,
    TermsAndConditionsModule
  ],
  exports: [
    ProductResourcesComponent
  ]
})
export class ResourcesModule {
}
